import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core";
import { v4 } from "uuid";
import moment from "moment";

import ScalingContext from "../../../../../../../context/scaling/ScalingContext";
import AuthContext from "../../../../../../../context/auth/AuthContext";

import AdminAction from "./Admin";
import NonAdminAction from "./NonAdmin";

export default function Action(props) {
  const useStyles = makeStyles((theme) => ({
    headerWrapper: {
      paddingTop: 20,
    },
    tableWrapper: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 5,
      marginTop: 8,
    },
    actionSeperator: {
      borderTop: `1px solid ${theme.palette.divider}`,
    },
    actionWrapper: {
      padding: "10px 0",
    },
    label: {
      paddingRight: 40,
    },
    buttonWrapper: {
      textAlign: "center",
    },
  }));
  const classes = useStyles();

  const { default_scaling_data, campaign_selected } =
    useContext(ScalingContext);
  const { user } = useContext(AuthContext);

  const { scaling_actions, setScalingActions } = props;

  const handleAdd = () => {
    // Function: Add New Scaling Action
    let new_object = { ...default_scaling_data };
    new_object.campaign_id = campaign_selected.campaign_id;
    new_object.action_id = v4();
    new_object.created_at = moment().format("YYYY-MM-DD HH:mm:ss");

    setScalingActions([...scaling_actions, new_object]);
  };

  const handleDelete = (action_id) => {
    // Function: Delete Scaling Action
    setScalingActions(
      scaling_actions.filter((action) => action.action_id !== action_id)
    );
  };

  const handleChange = (e) => {
    // Function: Change on Scaling Action's Values
    const index = parseInt(e.target.id);
    const id = e.target.name;
    const value = e.target.value;

    let new_array = JSON.parse(JSON.stringify(scaling_actions));

    if (id === "actions") {
      new_array[index][id] = value.slice(0, 1000);
    } else if (id === "status") {
      new_array[index][id] = value;
    }

    setScalingActions(new_array);
  };

  return user.user_group === "admin" ? (
    <AdminAction
      classes={classes}
      handleAdd={handleAdd}
      handleChange={handleChange}
      handleDelete={handleDelete}
      scaling_actions={scaling_actions}
    />
  ) : (
    <NonAdminAction
      classes={classes}
      handleChange={handleChange}
      scaling_actions={scaling_actions}
    />
  );
}
